import * as types from '../actiontypes';
import Utility from '../../util/utilityfunctions';

export function getAllDocumentExtensions(engagementId, documentId) {
	let url = Utility.getDocumentChangeReasonApiUrl(engagementId, documentId);

	return {
		type: types.GET_ALL_DOCUMENT_EXTENSION,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function createDocumentChangeComment(engagementId, documentId, data) {
	let url = Utility.getDocumentChangeReasonApiUrl(engagementId, documentId);

	return {
		type: types.CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
}

export function updateDocumentChangeComment(
	engagementId,
	documentId,
	documentExtensionId,
	data
) {
	let url =
		Utility.getDocumentChangeReasonApiUrl(engagementId, documentId) +
		documentExtensionId;

	return {
		type: types.UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}